// @ts-nocheck

import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { ModalContentSpacing } from '../../constants/ui/modal';
import { getPortalRootDOMElement } from '../../DOMElements';
import usePictureInPicture from '../../hooks/usePictureInPicture';
import { Modal as ModalTheme } from '../../styled-components/dark/modal';
import { type MultiviewDisplayMode } from '../../types/multiview';
import Modal from '../Modal';
import MultiviewBlockList from '../MultiviewBlockList';
import MultiviewModalBlockPickerContainer from '../MultiviewModalBlockPicker/MultiviewModalBlockPickerContainer';
import ScaleTransitionGroup from '../ScaleTransitionGroup';

type MultiviewProps = {
  showMatchList: boolean;
  onMountMultiview: (...params: unknown) => unknown;
  onUnmountMultiview: (...params: unknown) => unknown;
  handleCloseMatchList: (...params: unknown) => unknown;
  list: Array<number>;
  itemPerLine: number;
  userOption: number;
  isWTVEnabled: boolean;
  showWTV: boolean;
  mode: MultiviewDisplayMode;
  height?: number;
  setDisplayOptions: (...params: unknown) => unknown;
  setShowWinamaxTv: (...params: unknown) => unknown;
};

// Desktop version
const Multiview = ({
  showMatchList,
  onMountMultiview,
  onUnmountMultiview,
  handleCloseMatchList,
  ...rest
}: MultiviewProps) => {
  const [isReady, setIsReady] = useState(false);
  const { closeStream } = usePictureInPicture();

  // The ready state is needed because the mode is not set to
  // multiview when the component first mounts
  useEffect(() => {
    onMountMultiview();
    setIsReady(true);
    return () => {
      onUnmountMultiview();
      setIsReady(false);
    };
  }, [onMountMultiview, onUnmountMultiview]);

  useEffect(() => {
    // we close stream on multiview
    closeStream();
  }, [closeStream]);

  return (
    <div>
      {isReady ? <MultiviewBlockList {...rest} /> : null}
      {createPortal(
        <>
          <ScaleTransitionGroup>
            {showMatchList ? (
              <Modal
                backgroundColor={ModalTheme.backgroundColor.default}
                contentSpacing={ModalContentSpacing.NONE}
                closeOnEsc
                closeOnOutsideClick
                hasCloseButton
                hasOverlay
                onClose={handleCloseMatchList}
                forbidBackgroundScrolling
              >
                <MultiviewModalBlockPickerContainer />
              </Modal>
            ) : null}
          </ScaleTransitionGroup>
        </>,
        getPortalRootDOMElement(),
      )}
    </div>
  );
};

export default Multiview;
